<template>
  <div class="step_container">
    <a-form-model
        ref="entity_six_form"
        layout="horizontal"
        :rules='rules'
        :model="fourthForm"
      >
    <h1 class="step_title">ACKNOWLEDEMENT 责任书</h1>
    <!-- FATCA AND CRS DECLARATION FATCA和CRS宣言 -->
    <div class="step_question_container">
      <a-collapse>
        <a-collapse-panel key="1" class="collapse-item-header" header="FATCA AND CRS DECLARATION FATCA和CRS宣言">
          <!-- <h2 class="step_question_title">
            FATCA AND CRS DECLARATION FATCA和CRS宣言
          </h2> -->
          <div class="step_sub_title">
            Please read it carefully and consent the declaration. 请仔细阅读并同意声明。
          </div>
          <p class="claim_text">
            Each jurisdiction has its own rules for defining tax residence, and jurisdictions have provided information on how to determine if you are resident in the jurisdiction on the following website: <a href="http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-residency/">http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-residency/</a>. In general, you will find that tax residence is the country/jurisdiction in which you live. Special circumstances may cause you to be resident elsewhere or resident in more than one country/jurisdiction at the same time (dual residency). For more information on tax residence, please consult your tax adviser or the information at the OECD automatic exchange of information portal mentioned above.
          </p>
          <p class="claim_text">
            每个司法管辖区都有自己的税收居住定义规则，司法管辖区提供了如何确定您是否居住在以下网站的管辖区内的信息：<a href="http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-residency/">http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-residency/</a>。 一般而言，您会发现税务居住地是您居住的国家/地区。 特殊情况可能导致您居住在其他地方或同时居住在多个国家/地区（双重居住）。有关税务居住的更多信息，请咨询您的税务顾问或上述经合组织自动交换信息门户网站上的信息
          </p>
          <ol>
            <li>Under penalties of perjury, I declare that I have examined the information in Section 2 and to the best of my knowledge and belief it is true, correct, and complete.</li>
            <li>I agree to disclose the information mentioned above to any third party or competent authority responsible for the FATCA/CRS compliance.</li>
            <li>I understand and agree that on specific request from any relevant tax authorities or any party authorized to audit or conduct a similar control for tax purposes, the information contained in this section and/or a copy of this form can be disclosed to such tax authorities or such party.</li>
            <li>In case of any change in circumstances that causes the information contained herein to become incorrect I recognize that I will have to provide a suitable updated declaration within 30 days of such change in circumstances.</li>
          </ol>
          <ol>
            <li>根据伪证处罚，我声明我已经检查了前面所有的信息，并且据我所知和所信，这是真实的，正确的和完整的。</li>
            <li>我同意向负责FATCA / CRS合规的任何第三方或主管当局披露上述信息。</li>
            <li>我理解并同意，根据任何相关税务机关或任何被授权审计或进行类似控制以进行税务控制的一方的具体要求，本节中包含的信息和/或本表格的副本可以向此类税收披露。 当局或此类政党。</li>
            <li>如果导致此处包含的信息不正确的情况发生任何变化，我认为我必须在情况发生变化后的30天内提供适当的更新声明。</li>
          </ol>
          <p class="claim_text mt-20px">
            Please be advised that penalties under the AEOI laws may apply if you provide false or misleading information, fail to provide this information, or fail to provide an update if there is a material change to the information you have provided. This includes civil penalties of $1,000 per offence that Inland Revenue can apply. Substantial criminal penalties can be applied by the courts for knowledge-based offences. These penalties apply for the purposes of both FATCA and CRS.<br>
            请注意，如果您提供虚假或误导性信息，未提供此信息或未提供更新，如果您提供的信息发生重大变更，则AEOI法律规定的处罚可能适用。 这包括国内税收可以适用的每次犯罪1000美元的民事处罚。 法院可以对基于知识的犯罪实施重大刑事处罚。 这些处罚适用于FATCA和CRS的目的。
          </p>
        </a-collapse-panel>
      </a-collapse>
      <a-form-model-item prop="entity_crs_announcement_check"
      >
        <a-checkbox
        :disabled='disabled'
        name="entity_crs_announcement_check"
        class="mod_antd_checkbox"
        label="Activity name"
        v-model="fourthForm.entity_crs_announcement_check"
        @change="handleCheckChange">
            Read & Consent 已读确认
          </a-checkbox>
      </a-form-model-item>
    </div>
    <!-- ACKNOWLEDEMENT 责任书 -->
    <div class="step_question_container">
      <a-collapse>
        <a-collapse-panel key="1" class="collapse-item-header" header="ACKNOWLEDEMENT 责任书">
          <!-- <h2 class="step_question_title">
            ACKNOWLEDEMENT 责任书
          </h2> -->
          <div class="step_sub_title">
            Electronic Verification 电子认证
          </div>
          <p class="claim_text mt-10px">
            To meet the requirements under the Anti-Money Laundering and Countering Financing of Terrorism Act 2009 (AML/CFT Act), we must verify our client’s identity and residential address. 根据新西兰的《反洗钱及打击资助恐怖主义行为法》（以下简称反洗钱法），我们必须验证客户的身份以及住址。 One option is to try and do this electronically; however, as not everyone can be verified electronically, please be advised that we may still contact you for further verification if the electronic verification fails. 我们可以通过电子认证来验证你的身份和住址，然而并不是所有人都可以通过电子认证。所以如果你无法通过电子认证，我们将会再次联系你，并通过其他合法合规手段来验证你的身份和住址。 As part of the electronic verification processes, your personal details are disclosed to and matched with information held by the issuer of the identity document containing your personal details e.g. your drivers’ licence or the official record holder of your information, via third party systems. 电子认证将通过一个第三方系统，把你提供的个人信息与你所持身份证件的发行机构的数据库信息进行对比。 We will only use your personal details for the purpose of verification under the AML/CFT Act. 我们仅会依据反洗钱法的要求使用你的个人信息来进行验证。 By signing this form, you agree to verify your identity and address electronically against government related identifiers and other authoritative data sources. 签署此申请表表示你同意我们使用你的身份和地址信息，与政府部门数据库或其他权威部门数据库所持有的你的个人信息对比从而进行电子认证。
          </p>
          <div class="step_sub_title mt-40px">
            Anti-Money Laundering and Countering Financing of Terrorism Act 2009反洗钱及打击资助恐怖主义行为法
          </div>
          <p class="claim_text mt-10px">
            I/We acknowledge that the service providers (SP) are subject to AML/CFT laws in New Zealand. This may include reporting of suspicious transactions required by AML/CFT laws to the Commissioner of the New Zealand Police. 我/我们认可服务商必须遵守反洗钱法, 这包括向新西兰警方报告可疑行为。 I/We acknowledge that SP may use a third party system to verify my identity to determine whether I am/we are recorded with any notation as Politically Exposed Persons and whether I/we have a criminal record. 我/我们认可服务商使用第三方系统来确认我的身份，确认我/我们是否为政治敏感人物以及是否有犯罪记录。 I/We agree to provide SP (and its employees, agents, nominees and related entities) with reliable information and other assistance it reasonably requires to establish the bona fides of the source of my/our funds/wealth, and to comply with the AML/CFT laws. 我/我们同意根据反洗钱法的要求，向服务商（包括其员工，代理人，委托人及关联实体）提供可靠的材料及配合其他合理要求来证明真实的资金或资产来源。 I/We represent and warrant that I/we have no cause to believe the funds used to FX trades are the proceeds of crime or will be used to finance terrorism. 我/我们保证所用于外汇交易的资金不是犯罪收益，也不会用于资助恐怖主义行为。 I/We agree to indemnify SP (and its employees, agents, nominees and related entities) against any loss it suffers as a result of me/us providing incorrect or incomplete information. 如果因为我/我们提供信息错误或不完全而导致服务商（包括其员工，代理人，委托人及关联实体）遭受损失，我/我们同意赔偿。 I/We understand that failure to comply with the reasonable request for information by SP to satisfy AML/CFT laws will result in my/our application being rejected. 我/我们理解如果无法根据合理要求提供信息来满足反洗钱法的要求，我/我们的账户申请会被拒绝。
          </p>
          <div class="step_sub_title mt-40px">
            Personal Information and Privacy Act 隐私权法
          </div>
          <p class="claim_text mt-10px">
            I/We consent and agree that all information about me/us disclosed in this form may be used by SP (and its employees, agents, nominees and related entities) or disclosed to and used for the purpose of completing/monitoring the transactions, including disclosure to the regulatory bodies and in compliance with the AML/CFT laws.
    我/我们同意服务商（包括其员工，代理人，委托人及关联实体）将会使用我/我们提供的信息依照反洗钱法的要求进行账户监控，并依法将这些信息披露给相关政府部门。 I/We know that SP may use the information on this form for the purpose of: 我/我们知道服务商会将本申请表内的信息用于如下用途：
          </p>
          <ul class="step_ul_style">
            <li>Creating and maintaining risk related models, including but not limited to risk assessment, risk analysis and risk management;
    创建风险模型，包括风险评估，风险分析以及风险管理等；</li>
    <li>Fulfilling reporting obligations, including but not limited to Annual AML/CFT Report, SAR, PTR, CRS, FATCA and any other reporting obligations imposed by New Zealand laws and regulations; 履行法定报告任务，包括年度反洗钱报告，可疑行为报告，法定交易报告，金融账户涉税信息报告，海外账户税收合规报告（美国）等；</li>
    <li>Responding to the inquiries of banks or any other regulatory bodies; 回复银行或其他管理部门的问询；</li>
    <li>Marketing products, services and other subjects under the umbrella of Skyline Limited旗下的产品与服务项目进行市场营销；</li>
    <li>Meeting the requirements to make disclosure under the requirements of any law binding on us or under and for the purpose of any guidelines issued by regulatory bodies or other authorities to comply; 履行适用的法律法规或指引下的信息披露义务；</li>
    <li>Any other purposes relating to the purposes listed above. 任何其他与上述目的相关的。 I/We know that I/we can request such access to and correction of any information held about me/us by SP. 我/我们知道我/我们可以要求获取服务商所持有的关于我/我们的信息，也有权要求更正相关信息。 Notwithstanding the foregoing, I/we acknowledge that where a suspicious activity report has been made about me/us, the person who has made that report is not able to give me/us access to any information about that report (including its existence) and I/we have no right to request information in that report to be corrected. <br>尽管如此，我/我们认可如果一个关于我/我们的可疑行为报告被提交了，报告提交人/服务商依法不能给我/我们提供任何关于这个报告的信息，甚至该报告的存在性。我/我们也无权请求更正该报告的内容。 I/We will inform SP of any changes to the information provided by me/us to SP. 如果我/我们提交的信息有所变更，我/我们会通知服务商。</li>
          </ul>
          <div class="step_sub_title mt-40px">
            1. United Stated (US) Foreign Account Tax Compliance Act (FATCA) 外国账户纳税法案（美国） Automatic Exchange of Information (AEOI) and the Common Reporting
          </div>
          <div class="step_sub_title">
            Standard (CRS) 金融账户涉税信息自动交换标准
          </div>
          <p class="claim_text">
            I/We acknowledge that SP have certain obligations to report information held about me/us under FATCA and CRS and I/we consent to SP (and its employees, agents, nominees and related entities) disclosing all such information to the necessary parties. 我/我们认同服务商在外国账户纳税法案（美国）和金融账户涉税信息自动交换标准及共同申报准则下有依法报告的法定义务。我/我们同意服务商（包括其员工，代理人，委托人及关联实体）依法将信息披露给必要的相关方。 I/We acknowledge that I/we have examined the information provided and it is true, correct, and complete to the best of my/our knowledge and belief. 我/我们确认我/我们已经检查过所提交的信息是真实的，正确的和完整的。 I/We understand and agree that on specific request from any relevant tax authorities or any party authorized to audit or conduct a similar control for tax purposes, the information contained in this section and/or a copy of this form can be disclosed to such tax authorities or such party. 我/我们理解并同意如果相关税务部门或其他授权部门要求，我/我们所提供的信息包括本申请表会披露给相关税务部门或授权部门。 In case of any change in circumstances that causes the information contained herein to become incorrect I/we recognize that I/we will have to provide a suitable updated declaration within 30 days of such change in circumstances. 如果有情势变更导致提供的信息不再正确，我/我们认可我/我们会在情势变更的30天之内向服务商提供更新声明。

          Please be advised that penalties under the AEOI laws may apply if you provide false or misleading information, fail to provide this information, or fail to provide an update if there is a material change to the information you have provided. This includes civil penalties of $1,000 per offence that Inland Revenue can apply. Substantial criminal penalties can be imposed by the courts for knowledge-based offences. These penalties apply for the purposes of both FATCA and CRS. 敬请注意，如果你提供虚假信息，或不提供信息，或未在重大情势变更后更新信息，你将会受到惩罚。惩罚包括税务局对你做出的每项违法行为1000纽币的处罚，以及法庭依法对重大刑事犯罪做出的处罚。惩罚适用于外国账户纳税法案（美国）以及金融账户涉税信息自动交换标准。
          </p>
        </a-collapse-panel>
      </a-collapse>
      <a-form-model-item prop="entity_acknowledement_check">
        <a-checkbox
        :disabled='disabled'
        name="entity_acknowledement_check"
        v-model="fourthForm.entity_acknowledement_check"
        class="mod_antd_checkbox"
        @change="handleCheckChange">
            Read & Consent 已读确认
          </a-checkbox>
      </a-form-model-item>
    </div>
    <!-- Terms and Conditions – Ie Money Limited条款和条件 -->
     <div class="step_question_container">
      <a-collapse>
        <a-collapse-panel key="1" class="collapse-item-header" header="Terms and Conditions – Skyline Limited 条款和条件">
          <TermAndCondition></TermAndCondition>
        </a-collapse-panel>
      </a-collapse>
      <a-form-model-item prop="entity_term_condition_check">
          <a-checkbox
        name="entity_term_condition_check"
        :disabled='disabled'
        class="mod_antd_checkbox"
        v-model="fourthForm.entity_term_condition_check"
        @change="handleCheckChange">
            Read & Consent 已读确认
          </a-checkbox>
      </a-form-model-item>
    </div>
    <!-- Signature 申请人签字 -->
    <div class="step_question_container">
      <h2 class="step_question_title">
        Signature 申请人签字
      </h2>
      <p class="claim_text">I declare all of the information I have provided above is correct. 我声明<span @dblclick="handleOpenSecret">我</span>上面提供的所有信息都是正确的。</p>
      <a-form-model-item
      ref='self_sign'
      prop="entity_self_signature_key"
      >
      <Signature
       :disabled='disabled'
        name="entity_self_signature_key"
        class="marginX20"
        :outsourceSign='self_sign'
        @upLoadSignKey='handleSignUpload'
      ></Signature>
      <AUploadFile v-if="showSecrect"
      prop='main'
      @handleFileChange="handleFileList"
      ></AUploadFile>
      </a-form-model-item>
      <div class="claim_text">
        You can generate a signature link for sending and signing. To confirm the signature after submitting,please refresh this page.     生成签名链接用于发送给客户签字，确认签字提交后请
      </div>
        <button
        class=" my-2 px-2 py-1 border-black-75 shadow-md border rounded-md block fetch_sign"
        :disabled='disabled'
        @click="refreshSign"
        >点击此处</button>
      <button
      :disabled='disabled'
      @click='handleShowGenerate' v-show="get_show_generate_link" class="generate_btn">Generate the Link 生成链接</button>
      <div v-show="!get_show_generate_link" class="general_sign_container">
              <div class="general_sign_title">Copy link to share 复制链接分享</div>
            <div class="general_sign_url">
              {{getShareLink}}
            </div>
            <button
            :data-clipboard-text="getShareLink" ref="copy_btn" class="copy_link_btn">Copy Link 复制链接</button>
          <span v-if="is_copy_success === true" class="copy_success_text">Successfully copied 已复制成功</span>
      </div>
    </div>
    </a-form-model>
  </div>
</template>

<script>
// import textSign from '../../../../utils/Sign'
import rules from '@/assets/rules/entitySixthRules.js'
import { mapState, mapActions, mapGetters } from 'vuex'
import Signature from '../../../../components/Signature.vue'
import Clipboard from 'clipboard'
import AUploadFile from '@/components/AUploadFile.vue'
import { getAwsPic, fetchSign, uploadSign } from '@/api/common'
import TermAndCondition from '@/components/TermAndCondition.vue'

export default {
  components: {
    Signature,
    AUploadFile,
    TermAndCondition
  },
  created () {
    this.rules = rules
    if (this.entity_self_signature_key) {
      this.fetchSign(this.entity_self_signature_key, 'self_sign')
    }
  },
  mounted () {
    const btnCopy = new Clipboard(this.$refs.copy_btn)
    btnCopy.on('success', (e) => {
      this.is_copy_success = true
      e.clearSelection()
    })
    btnCopy.on('error', e => {
      this.$message.warning('该浏览器不支持自动复制')
      btnCopy.destroy()
    })
  },
  data () {
    return {
      self_sign: null,
      show_generate_link: false,
      url: this.getShareLink,
      is_copy_success: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 12 },
      secrect: ''
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.disabled) {
      next()
    } else {
      this.$refs.entity_six_form.validate(valid => {
        if (valid) {
          next()
        } else {
          next()
        }
      })
    }
  },
  watch: {
    entity_self_signature_key (newValue) {
      this.fetchSign(newValue, 'self_sign')
    }
  },
  destroyed () {
    window.addEventListener('keypress', null)
  },
  methods: {
    handleOpenSecret () {
      window.addEventListener('keypress', ({ key }) => {
        this.secrect += key
      })
    },
    refreshSign () {
      const query = {
        type: 'entity_main'
      }
      fetchSign(query).then(res => {
        this.ChangeFormAction({ content: 'entity_self_signature_key', value: res.signature })
        this.fetchSign(res.signature, 'self_sign')
      }).catch(() => {
        this.$message.error('Server is Busy')
      })
    },
    validateField (field) {
      this.$refs.entity_six_form.validateField(field)
    },
    fetchSign (from, x) {
      const query = {
        key: from
      }
      getAwsPic(query).then(res => {
        if (res.url) {
          this[x] = res.url
        }
      })
    },
    handleFileList (fileList, type) {
      const url = fileList.pop().key
      const query = {
        customer_type: 'E',
        signature_url: url,
        type: 'entity_main',
        username: this.attributes.username
      }
      uploadSign(query).then(() => {
        this.$message.success('上传成功')
      })
    },
    handleCheckChange (e) {
      const { checked, name } = e.target
      this.ChangeFormAction({ content: name, value: checked })
    },
    handleSignUpload (content, val) {
      this.ChangeFormAction({ content, value: val })
      this.validateField(content)
    },
    handleShowGenerate () {
      this.show_generate_link = true
    },
    ...mapActions('entityStepSix', ['ChangeFormAction'])

  },
  computed: {
    ...mapGetters({
      disabled: 'login/getComplainceActive'
    }),
    showSecrect () {
      if (this.secrect.includes('wwssaaddieie')) {
        return true
      } else {
        return false
      }
    },
    getShareLink () {
      if (this.attributes && this.attributes.username) {
        return `${window.location.host}/signpage/?username=${this.attributes.username}&type=entity_main&customer_type=E&token=${encodeURI(JSON.stringify(this.AwsToken))}`
      }
      return null
    },
    get_show_generate_link () {
      return this.show_generate_link === false
    },
    fourthForm () {
      return this.$store.state.entityStepSix
    },
    ...mapState('login', ['AwsToken', 'user', 'attributes']),
    ...mapState('entityStepSix', ['entity_self_signature_key'])
  }
}
</script>

<style scoped>

.step_container {
  background: rgb(248, 248, 248);
  padding: 0 1rem;
}

.step_sub_title {
  margin: 20px 0;
  font-size: 17px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
}
ol{
  margin-top: 1rem;
  list-style-type: decimal;
  padding-left: 25px;
  font-size: 15px;
}
.claim_text{
  font-weight: 300;
  font-size:15px;
  line-height: 24px;
}
.mt-10px{
  margin-top: 10px;
}
.mt-20px{
  margin-top: 20px;
}
.mt-40px{
  margin-top: 40px;
}
.step_ul_style {
  list-style-type: inside;
  list-style-type: disc;
  padding-left: 20px;
  font-size: 15px;
  font-weight: 300;
}
.step_ul_style li {
  line-height: 24px;
}
.marginX20{
  margin: 20px 0;
}
.generate_btn{
  border: 1px solid #ea7840;
  color: #ea7840;
  padding: 10px;
  font-size: 15px;
  font-weight: 300;
  background-color: #fff;
  outline: none;
  margin-top: 5px;
  transition: .2s;
}
.generate_btn:hover{
  background-color:#ea7840;
  color: #fff;
}
.generate_btn:disabled{
  cursor: not-allowed;
}
.general_sign_container{
  margin-top: 10px;
  background: #f8f8f8;
  padding:10px;
}
.general_sign_title{
  font-size: 15px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
}
.general_sign_url{
  font-weight: 300;
  margin-top:5px;
  white-space: normal;
  word-break: break-all;
}
.copy_link_btn{
  background-color: #ea7840;
  color: #fff;
  padding: 3px;
  font-size: 14px;
  transition: .2s;
  outline: none;
  display: block;
  margin: 5px 0;
}
.copy_link_btn:hover{
  background: #f09f74;
}
.copy_success_text{
  font-weight: 300;
  color: red;
  font-size: 13px;
}
.mod_antd_checkbox {
  font-weight: bold;
  font-size: 17px!important;
  color: rgba(0, 0, 0, 0.85);
}
.mod_antd_checkbox >>> .ant-checkbox-inner{
  border-color: rgba(0, 0, 0, 0.85);
  width: 30px;
  height: 30px;
}
.mod_antd_checkbox >>> .ant-checkbox-inner::after{
  width: 9px;
  height: 18px;
}
.ant-form >>> label{
  font-size: 15px;
}
.collapse-item-header {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 500;
}
</style>
